module.exports = __webpack_public_path__ + "static/media/2.06b32224.jpg";